<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
    let image;
</script>

<div class="main-div">
    <div class="image" bind:this={image}>
        <img
            src="/images/createmain/section4.png"
            alt=""
            height="100%"
            width="100%"
        />
    </div>
    <div
        class="second-div"
        on:mouseenter={() => {
            image.style.filter = 'none';
        }}
        on:mouseleave={() => {
            image.style.filter = 'grayscale(1)';
        }}
    >
        <p class="text1">STORYTELLERS & Opus</p>
        <p class="text2">
            FICTION
            <br />
            WRITERS
        </p>
        <p class="text3">
            Whether you are particular about how it should have ended or
            disagree on how little action was given to your favorite character
            in a series, you don’t idly sit, you alter, extend and add depth to
            your favorite story and characters.
        </p>

        <p class="text4">
            We’re building a platform that makes producing movies and games just
            as much a collaborative process for everyone as fanfiction writing
            is. More importantly, the derivatives are just as real as the
            original.

            <br />
            <br />
            Fix that ending, join our governing council now!
        </p>
        <div style="margin-top:5vh;">
            <DesktopButton2
                state = "StoryTeller"
                text1="Join Storytellers Governance Council"
                text2="(Fiction Author Seat)"
                AnimationColor = #A53BD6
                width="31.611vh"
                BorderColorAfter="0.0052vw solid #A53BD6"
            />
        </div>
    </div>
</div>

<style>
    p {
        font-family: "Orbitron";
        margin: 0;
    }
    .main-div {
        width: 145.463vh ;
        height: 100vh;
        position: relative;
    }
    .second-div {
        width: 42.685vh ;
        position: absolute;
        height: 92.87vh ;
        background-color: white;
        top: 0;
        left: 16.019vh ;
        padding-left: 5.926vh ;
    }
    .text1 {
        font-size: 1.296vh ;
        font-weight: 400;
        padding-top: 24.352vh ;
    }
    .text2 {
        color: #a53bd6;
        font-size: 5.556vh ;
        line-height: 5.556vh ;
        font-weight: 800;
        margin-top: 1.481vh;
    }
    .text3 {
        font-size: 1.296vh ;
        font-weight: 400;
        width: 37.037vh ;
        margin-top: 6.204vh ;
        line-height: 1.815vh;
        letter-spacing: 0.05vw;
    }
    .text4 {
        font-size: 1.296vh ;
        width:39.722vh ;
        font-weight: 700;
        line-height: 2.043vh;
        letter-spacing: 0.05vw;
        margin-top: 2.593vh;
    }
    .image {
        transition-duration: 1.5s;
        filter: grayscale(1);
        width: 145.463vh ;
        height: 100%;
    }
    .image::before {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0) (255, 255, 255);
    }
</style>
